import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, CheckCircle2, RefreshCw } from "lucide-react";
import { api, apiError } from "@/lib/api";

const FESTIVI_FISSI = ["01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-07", "12-08", "12-25", "12-26"];

/** Ore trascorse dall'ultima sincronizzazione contando solo la finestra lavorativa 8-19, lun-ven. */
function oreLavorativeDa(ultima) {
  const da = new Date(ultima);
  const ora = new Date();
  let ore = 0;
  const cursore = new Date(da);
  cursore.setMinutes(0, 0, 0);
  cursore.setHours(cursore.getHours() + 1);
  while (cursore <= ora) {
    const festivo = FESTIVI_FISSI.includes(cursore.toISOString().slice(5, 10));
    const h = cursore.getHours(), g = cursore.getDay();
    if (g >= 1 && g <= 5 && !festivo && h >= 9 && h <= 19) ore += 1;
    cursore.setHours(cursore.getHours() + 1);
  }
  return ore;
}

/** Semaforo della sincronizzazione CRM: rosso se in orario lavorativo mancano da oltre 2 ore. Solo MASTER/ADMIN. */
export function StatoSync({ ultima, onSincronizzato }) {
  const [busy, setBusy] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60_000);
    return () => clearInterval(id);
  }, []);

  const sincronizza = async () => {
    setBusy(true);
    try {
      const r = await api.post("/crm/sincronizza");
      toast.success(`CRM sincronizzato · ${r.data.pratiche} pratiche, ${r.data.nuove} nuove`);
      onSincronizzato?.();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  const ore = ultima ? oreLavorativeDa(ultima) : null;
  const ritardo = ore === null || ore > 2;
  const quando = ultima
    ? new Date(ultima).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
    : "mai";
  void tick;

  return (
    <div data-testid="stato-sync-crm"
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold
        ${ritardo ? "border-red-300 bg-red-50 text-red-700" : "border-emerald-300 bg-emerald-50 text-emerald-700"}`}>
      {ritardo ? <AlertTriangle size={14} /> : <CheckCircle2 size={14} />}
      <span data-testid="stato-sync-testo">
        {ritardo
          ? `Sincronizzazione CRM ferma: ultima ${quando}${ore ? ` (${ore} h lavorative fa)` : ""}`
          : `CRM sincronizzato alle ${quando}`}
      </span>
      <button type="button" onClick={sincronizza} disabled={busy} data-testid="btn-sync-crm-ora"
        className={`ml-1 inline-flex items-center gap-1 rounded-full px-2 py-0.5 transition-colors duration-200
          ${ritardo ? "bg-red-600 text-white hover:bg-red-700" : "bg-emerald-600 text-white hover:bg-emerald-700"}
          disabled:opacity-60`}>
        <RefreshCw size={12} className={busy ? "animate-spin" : ""} /> {busy ? "In corso…" : "Sincronizza ora"}
      </button>
    </div>
  );
}
